import { Button, Icon, Table } from "simplydo/react/ui";
import { Input } from "simplydo/react/ui";

import { FieldProps, TableFieldValue } from "./FieldProps";

const TableField = ({
  field,
  fieldValue,
  updateIdea,
  isEditing,
}: FieldProps) => {
  const tableValue = (fieldValue as TableFieldValue) || {};
  const currentData = tableValue.data || [{}];
  const columns = field.columns || [];

  return (
    <Table>
      <Table.Header>
        <Table.Row>
          {columns.map((col) => (
            <Table.HeaderCell key={col.id}>
              {col.title}
              {col.required ?
                <span style={{ color: "#cd0e2b" }}>{"\u00A0*"} </span>
              : null}
            </Table.HeaderCell>
          ))}
          {isEditing ?
            <Table.HeaderCell />
          : null}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {currentData.map((row, rowIndex) => (
          <Table.Row key={rowIndex}>
            {columns.map((col) => {
              const cell = row[col.id] || { value: "" };

              return (
                <Table.Cell key={col.id}>
                  {isEditing ?
                    <Input
                      fluid
                      defaultValue={cell.value}
                      onChange={(_e, data) => {
                        const newData = [...currentData];
                        const row = newData[rowIndex] ?? {};
                        newData[rowIndex] = row;
                        row[col.id] = { value: data.value };
                        updateIdea({ ...(tableValue || {}), data: newData }, [
                          "templated",
                          field.id,
                        ]);
                      }}
                    />
                  : cell.value}
                </Table.Cell>
              );
            })}
            {isEditing ?
              <Table.Cell collapsing>
                <Button
                  basic
                  icon
                  onClick={() => {
                    const newData = currentData.filter(
                      (_row, i) => i !== rowIndex,
                    );
                    updateIdea({ ...(tableValue || {}), data: newData }, [
                      "templated",
                      field.id,
                    ]);
                  }}
                >
                  <Icon name="trash" />
                </Button>
              </Table.Cell>
            : null}
          </Table.Row>
        ))}
        {isEditing ?
          <Table.Row>
            <Table.Cell colSpan={(columns.length || 1) + (isEditing ? 1 : 0)}>
              <Button
                primary
                onClick={() => {
                  const newData = [...currentData, {}];
                  updateIdea({ ...(tableValue || {}), data: newData }, [
                    "templated",
                    field.id,
                  ]);
                }}
              >
                Add Row
              </Button>
            </Table.Cell>
          </Table.Row>
        : null}
      </Table.Body>
    </Table>
  );
};

export default TableField;
